<template lang="pug">
  .height-100
    h3.title Reportes de vacaciones
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarListaSolicitudes", key="lista_solicitudes")
        lista-solicitud-vacaciones(
          @close="mostrarListaSolicitudes = false"
        )
      .box(v-if="mostrarListaEmpleados", key="lista_empleados")
        lista-empleados-vacaciones(
          @close="mostrarListaEmpleados = false"
        )
</template>

<script>
import ListaSolicitudVacacionesComponent from './Component_Reporte_Lista_Solicitud_Vacaciones'
import ListaEmpleadosVacacionesComponent from './Component_Reporte_Lista_Empleados_Vacaciones'
export default {
  name: 'vacaciones-reportes',
  components: {
    'lista-solicitud-vacaciones': ListaSolicitudVacacionesComponent,
    'lista-empleados-vacaciones': ListaEmpleadosVacacionesComponent
  },
  props: ['tipo'],
  data () {
    return {
      mostrarListaSolicitudes: false,
      mostrarListaEmpleados: false
    }
  },
  watch : {
    tipo (value) {
      return this.rerun()
    }
  },
  created () {
    this.rerun()
  },
  methods: {
    rerun () {
      if (this.tipo === 'solicitud') {
        this.mostrarListaSolicitudes = true
        this.mostrarListaEmpleados = false
      } else if (this.tipo === 'empleado') {
        this.mostrarListaSolicitudes = false
        this.mostrarListaEmpleados = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Vacaciones_Reporte.vue?722b524a